export const variablesPreset = {
  'primary-turquoise': '#4eb3c5',
  'primary-green': '#00a74f',
  'white': '#ffffff',
  'tint-turquoise-4': '#cdf0f4',
  /*colorScheme: {
    light: {
      surface: {
        0: '#ffffff',
        50: '#f9f9fa',
        100: '#f6f6f6',
        200: '#e3e3e3',
        300: '#c8c8c8',
        400: '#69707a',
        500: '#707070',
      }
    },
    dark: {
      surface: {
        0: '#ffffff',
        50: '#393b3e',
        100: '#3F4349',
        200: '#69707a',
        300: '#c8c8c8',
        400: '#e3e3e3',
        500: '#707070',
      }
    }
  }*/
}
